import React, { Fragment, useContext } from "react";
import date from "date-and-time";
import { UiContext } from "contexts/ui-context";
import IconSad from "../../assets/svg/icon-sad.svg";

/**
 * Context API
 */
import useModal from "hooks/use-modal";

/**
 * Components
 */
import { FlexRow } from "components/flex-row/flex-row";
import BaseButton from "components/base-button/base-button";
import Heading from "components/heading/heading";
import IconSvgComponent from "components/svg-icon/svg-icon";
import Spacer from "components/spacer/spacer";
import { formatMoney } from "../../utils/formatMoney";
import IconBankAlt from "../../assets/svg/icon-bank-alt.svg";

const ModalOfferDeclined = (props) => {
  const { openModal, modalTypes } = useModal();
  const { account, submitAmount, offers } = props.modalProps;
  const pattern = date.compile("DD MMM YYYY");
  const dateOpened = new Date(account.opened);
  const typeString =
    account.type.charAt(0).toUpperCase() + account.type.slice(1);

  return (
    <Fragment>
      <div className="sticky-icon">
        <IconSvgComponent icon={IconSad} />
      </div>
      <div className="modal__heading">
        <h2>Sorry!</h2>
        <h4>Your offer was declined.</h4>
      </div>
      <Heading text={account.creditor.name} icon={IconBankAlt} />
      <dl>
        <dt>Reference Number</dt>
        <dd>#{account.creditor.ref_id}</dd>

        <dt>Balance</dt>
        <dd>${formatMoney(account.balance_current, 2, ".", ",")}</dd>

        <dt>Status</dt>
        <dd>{typeString}</dd>
      </dl>
      <Spacer height="10" />
      <dl>
        <dt>Resolution Offer</dt>
        <dd>${formatMoney(submitAmount, 2, ".", ",")}</dd>
      </dl>
      <FlexRow className="justify-content--space-between">
        <BaseButton
          type="button"
          className="btn--alt"
          onClick={() => openModal(modalTypes.ModalOffer, { account, offers })}
        >
          Try another offer
        </BaseButton>
        <BaseButton
          type="button"
          className="btn--primary"
          onClick={() => openModal(modalTypes.ModalMakePayment)}
        >
          Make Payment
        </BaseButton>
      </FlexRow>
    </Fragment>
  );
};

export default ModalOfferDeclined;
